/* BIG WOOL BALLS — global JS
   Hero parallax, measured from the original Wix site:
   the goat layer scrolls at 0.78x page speed (background at 1.0x),
   i.e. it shifts down 0.22px per 1px scrolled, with eased motion. */
/* Mobile hamburger menu */
(function () {
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.site-nav');
  if (!toggle || !nav) return;
  var close = nav.querySelector('.nav-close');
  toggle.addEventListener('click', function () { nav.classList.add('open'); });
  if (close) close.addEventListener('click', function () { nav.classList.remove('open'); });
  nav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { nav.classList.remove('open'); });
  });
})();

(function () {
  var goat = document.querySelector('[data-parallax]');
  if (!goat) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var factor = parseFloat(goat.getAttribute('data-parallax')) || 0.22;
  var ticking = false;

  function update() {
    goat.style.transform = 'translate3d(0,' + (window.scrollY * factor).toFixed(2) + 'px,0)';
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });

  update(); /* correct position immediately, even if page loads mid-scroll */
})();


/* Amazon click tracking (added) — fires a distinct event per button.
   Each tagged link carries:
     data-amz-event = Shopify custom event name (sent to Customer Events)
     data-amz-fb    = Meta event name (sent to fbq if a pixel is on the page)
   A Custom Pixel (Settings -> Customer events) forwards the Shopify events to Meta.
   This does not change any existing pixel/app settings. */
(function () {
  var links = document.querySelectorAll('[data-amz-event]');
  if (!links.length) return;
  links.forEach(function (el) {
    el.addEventListener('click', function () {
      var payload = {
        destination: el.getAttribute('href') || '',
        label: (el.textContent || '').trim(),
        page: location.pathname
      };
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish(el.getAttribute('data-amz-event'), payload);
        }
      } catch (e) {}
      try {
        if (window.fbq) {
          fbq('trackCustom', el.getAttribute('data-amz-fb') || el.getAttribute('data-amz-event'), payload);
        }
      } catch (e) {}
    }, { passive: true });
  });
})();
